// @ts-ignore
const appSetup = window.appSetup || {};
const DEFAULT_COUNTRY_VALUE = 'DEU';
const locale = appSetup.localization?.locale || 'en_US';

const state = () => ({
  allCountries: null,
  currentCountry: appSetup.localization.country,
  regions: [],
  regionsFetched: false,
  regionsIsFetching: false,
});

const mutations = {
  setCurrentCountry(currentState, payload) {
    currentState.currentCountry = payload;
  },
  setAllCountries(currentState, payload) {
    currentState.allCountries = payload;
  },
  setRegions(currentState, payload) {
    currentState.regions = payload;
  },
  setRegionsFetched(currentState, payload) {
    currentState.regionsFetched = payload;
  },
  setRegionsIsFetching(currentState, payload) {
    currentState.regionsIsFetching = payload;
  },
};

const actions = {
  async getCountriesWithGeoSupport({ state: currentState, commit }) {
    if (currentState.regionsFetched) return;
    if (currentState.regionsIsFetching) return;
    commit('setRegionsIsFetching', true);
    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('appSetup.countryOptions', { locale }),
      );
      commit('setRegions', data.countriesWithGeoSupportByContinent || []);
      commit('setRegionsIsFetching', false);
      commit('setRegionsFetched', true);
    } catch (e) {
      console.error(e);
      commit('setRegionsIsFetching', false);
      commit('setRegionsFetched', true);
    }
  },
  setCurrentCountry({ commit, getters }) {
    let country = getters.getAvailableCountryByCountryValue(appSetup.user?.searchCountry?.value);
    if (!country) {
      country = getters.getAvailableCountryByCountryValue(appSetup.localization.country.value);
    }
    if (!country) {
      country = getters.getCountryByCountryValue(DEFAULT_COUNTRY_VALUE);
    }
    commit('setCurrentCountry', country);
  },
  async getAllCountries({ state: currentState, commit }) {
    if (currentState.allCountries) return;
    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('appSetup.allCountryOptions') + '/' + locale,
      );
      if (data.allCountries) {
        commit('setAllCountries', data.allCountries || null);
      }
    } catch (e) {
      console.error(e);
    }
  },
};

const getters = {
  allCountries: (currentState) => currentState.allCountries,
  currentCountry: (currentState) => currentState.currentCountry,
  countryOptions: () => appSetup.localization.supportedSearchCountries,
  getAvailableCountryByCountryValue: () => (countryValue) =>
    appSetup.localization.supportedSearchCountries.find(({ value }) => value === countryValue),
  getCountryByCountryValue: (currentState) => (countryValue) =>
    appSetup.localization.supportedSearchCountries.find(({ value }) => value === countryValue) ||
    currentState.currentCountry,
  getCountryByCountryCode: () => (code) =>
    appSetup.localization.supportedSearchCountries.find(({ countryCode }) => countryCode === code),
  formattedRegions: (currentState) =>
    currentState.regions.map(({ title, countries }) => ({
      title,
      options: countries.map(({ title: label, code }) => ({
        label,
        value: code,
      })),
    })),
  localeCountry: () => {
    return appSetup.localization.country;
  },
  language: () => appSetup.localization.language,
  countryBaseUrl: (currentState, currentGetters) => {
    const language = appSetup.localization.language;
    return !language || language === 'en' ? '/' : `/${language}/`;
    // let localeCountry = currentGetters.localeCountry?.countryCode?.toLowerCase();
    // return !localeCountry || localeCountry === 'us' ? '/' : `/${localeCountry}/`;
  },
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
